<template>
  <section class="trash-container">
    <header>
      <table>
        <colgroup>
          <col />
          <col style="width: 72px;" />
          <col style="width: 82px;" />
          <col
            :style="[files.length > 8 ? { width: '44px' } : { width: '25px' }]"
          />
        </colgroup>
        <thead>
          <tr>
            <th
              @click="onSort('name')"
              style="text-align: left;"
              class="clickable"
            >
              Naam
            </th>
            <th @click="onSort('realSize')" class="align-right clickable">
              Grootte
            </th>
            <th @click="onSort('deleted')" class="align-right clickable">
              Verwijderd
            </th>
            <th></th>
          </tr>
        </thead>
      </table>
    </header>
    <main class="trash-main">
      <table>
        <colgroup>
          <col />
          <col style="width: 72px;" />
          <col style="width: 82px;" />
          <col style="width: 25px;" />
        </colgroup>
        <tbody>
          <pre-loader
            message="De bestanden worden geladen."
            v-if="loading"
          ></pre-loader>
          <p class="placeholder empty-text" v-if="!loading && files.length < 1">
            De prullenmand is leeg
          </p>
          <tr v-for="(file, index) in displayFiles" :key="index">
            <td>
              <span class="name">{{ file.name }}</span
              ><br />
              <span class="file-path">
                <span v-for="(element, index) in file.splitPath" :key="index">
                  {{ element }}
                  <i
                    v-if="index < file.splitPath.length - 1"
                    class="chevron right divider"
                  ></i>
                </span>
              </span>
            </td>
            <td class="align-right" v-if="file.realSize === 0">Map</td>
            <td class="align-right" v-else>
              {{ $filters.formatFileSize(file.realSize) }}
            </td>
            <td class="align-right">{{ $filters.formatDate(file.deleted) }}</td>
            <td>
              <popup-menu anchor-position="right">
                <template #trigger>
                  <button class="kebab-btn"><span></span></button>
                </template>

                <menu-item @click="() => getTrashInfo(file)">Info</menu-item>
                <!--                 <menu-item @click="() => restoreFile(file)"
                  >Terugzetten
                </menu-item> -->
                <menu-item @click="() => deleteFile(file)"
                  >Verwijderen
                </menu-item>
              </popup-menu>
            </td>
          </tr>
        </tbody>
      </table>
    </main>
  </section>
</template>
<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import FileNavigationMixin from '@/features/filestore/FileNavigationMixin.js'
import { trashGet } from '@/features/filestore/FileStoreApi'
import * as fileStoreApi from '@/features/filestore/FileStoreApi'
import PreLoader from '@/components/ui/PreLoader.vue'
import * as fileStoreService from '@/features/filestore/FileStoreService.js'
import SortMixin from '@/mixins/SortMixin'
import { EventBus } from '@/eventbus/EventBus'
import { logger } from '@/logger'

export default {
  props: ['folderId'],
  components: { PreLoader },
  mixins: [FileNavigationMixin, SortMixin],
  data() {
    return {
      files: [],
      loading: true
    }
  },
  created() {
    EventBus.on('empty-trash-clicked', this.clearFiles)

    trashGet(this.folderId).then((files) => {
      this.files = files
      this.loading = false
    })
  },
  unmounted() {
    EventBus.off('empty-trash-clicked', this.clearFiles)
  },
  computed: {
    ...mapStores(useFileStoreStore),
    displayFiles() {
      return this.sortArray(this.files)
    }
  },
  methods: {
    clearFiles() {
      fileStoreApi
        .emptyTrash(this.folderId)
        .then(() => {
          this.files = []
        })
        .catch(() => logger.error('Legen prullenmand mislukt'))
    },
    restoreFile(file) {
      const isFolder = file.type === 'folder'
      const fileId = file.id
      fileStoreService.restoreFile(file)

      this.files = this.files.filter((item) => item.id !== file.id)

      setTimeout(() => {
        if (isFolder) {
          this.navigateToTargetFolder(fileId)
        } else {
          const file = this.fileStoreStore.getFile(fileId)
          this.navigateToTargetFolder(file.folderId)
        }
      }, 1000)
    },
    deleteFile(file) {
      if (file.type === 'file') {
        this.confirmationDialog(
          `Weet u zeker dat u het bestand <strong>${file.name}</strong> definitief wilt verwijderen?`,
          'Verwijderen',
          () => {
            fileStoreApi.deleteFiles([file.id]).then(() => {
              this.files = this.files.filter((item) => item.id !== file.id)
            })
          }
        )
      } else {
        this.confirmationDialog(
          `Weet u zeker dat u de map <strong>${file.name}</strong> definitief wilt verwijderen?`,
          'Verwijderen',
          () =>
            fileStoreApi.deleteFolder(file.id).then(() => {
              this.files = this.files.filter((item) => item.id !== file.id)
            })
        )
      }
    }
  }
}
</script>
<style scoped lang="scss">
.trash-container {
  height: 100%;
  display: grid;
  grid-template-rows: 40px 1fr;
}

.trash-main {
  overflow: auto;
}

table {
  margin-left: 10px;
  margin-right: 10px;
  width: calc(100% - 20px);
  border-collapse: collapse;
  color: var(--text-color);
  table-layout: fixed;

  thead {
    border-bottom: solid 1px #e6e6e6;

    tr {
      height: 38px;

      th {
        vertical-align: middle;
        padding-left: 5px;
        padding-right: 5px;

        .fs-align-left {
          text-align: left;
        }
      }
    }
  }

  .name {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    line-height: 14px;
  }

  tbody {
    overflow: auto;

    tr {
      height: 48px;
      //cursor: pointer;

      &.folder {
        font-weight: 600;
      }

      &.hover {
        background-color: var(--hover-color);
      }

      td {
        vertical-align: top;
        padding-top: 12px;
        padding-left: 5px;
        padding-right: 5px;
      }
    }
  }
}

.file-path {
  font-size: 11px;
  color: #9e9e9e;
  font-weight: 500;
  line-height: 24px;
}

.divider {
  color: #a8a8a8;
  transform: scale(0.5);
  margin-right: 4px;
}

.empty-text {
  padding: 20px 0 0 42px;
  width: 190px;
}
</style>
